// SEQ=10124 P8-CK-H — CommercialHarbor UX 모달
// 사양: SEQ-10119 §3-3 #8 + SEQ-10123 §1-2 #8
//   ── 모든 상대 강제 거래 — 본인 상품(WHEAT/WOOL/ORE/BRICK/WOOD 외 EXT_CK 상품)과
//      상대 자원(WHEAT/WOOL/ORE/BRICK/WOOD)을 1:1 강제 교환
//   ── 본 STEP=2에서는 명세 단순화: 모든 상대에 대해 본인 한 상품 → 상대 한 자원 (단일 페어)
//      (사양 §1-2 비고: "현재 1 대상 → 후속 보강 follow-up")
//   ── 다중 상대 pair 매트릭스는 별도 SEQ
import { CatanPlayer } from '../../store/catan'

/** EXT_CK 상품 자원 5종 (CITY_IMPROVE 부산물) — 단순화: 일반 자원 5종 동일 사용 */
const RES_TYPES = ['WHEAT', 'WOOL', 'ORE', 'BRICK', 'WOOD'] as const
type ResType = typeof RES_TYPES[number]

export interface CommercialHarborTradeModalProps {
  /** 본인 외 active 플레이어 */
  targets: CatanPlayer[]
  /** 사용자 입력 — 본인이 줄 상품 (모든 상대 공통) */
  myCommodity: ResType | ''
  /** 사용자 입력 — 받을 자원 (모든 상대 공통) */
  theirResource: ResType | ''
  onChangeMyCommodity:   (r: ResType | '') => void
  onChangeTheirResource: (r: ResType | '') => void
  /** 확인 → SignalR invoke */
  onConfirm: () => void
  onCancel:  () => void
  busy?: boolean
}

export default function CommercialHarborTradeModal({
  targets, myCommodity, theirResource,
  onChangeMyCommodity, onChangeTheirResource,
  onConfirm, onCancel, busy,
}: CommercialHarborTradeModalProps) {
  const canConfirm = !!myCommodity && !!theirResource && myCommodity !== theirResource

  return (
    <div style={backdrop} onClick={busy ? undefined : onCancel}>
      <div style={card} onClick={e => e.stopPropagation()}>
        <h3 style={title}>🏛️ 상업 항구 (Commercial Harbor)</h3>
        <div style={body}>
          모든 상대 {targets.length}명에게 강제 거래를 발동합니다 (1:1 교환).
        </div>
        <ul style={list}>
          {targets.map(t => <li key={t.userCode}>{t.nickname}</li>)}
        </ul>
        <div style={row}>
          <label>주는 상품(본인):</label>
          <select value={myCommodity} onChange={e => onChangeMyCommodity(e.target.value as ResType | '')} disabled={busy}>
            <option value="">선택</option>
            {RES_TYPES.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        <div style={row}>
          <label>받는 자원(상대):</label>
          <select value={theirResource} onChange={e => onChangeTheirResource(e.target.value as ResType | '')} disabled={busy}>
            <option value="">선택</option>
            {RES_TYPES.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        {myCommodity && theirResource && myCommodity === theirResource && (
          <div style={warn}>같은 자원으로 교환할 수 없습니다.</div>
        )}
        <div style={footer}>
          <button onClick={onCancel}  disabled={busy} style={btnSec}>취소</button>
          <button onClick={onConfirm} disabled={busy || !canConfirm} style={btnPri}>교환</button>
        </div>
      </div>
    </div>
  )
}

const backdrop: React.CSSProperties = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const card:     React.CSSProperties = { background: '#fff', padding: 16, borderRadius: 6, minWidth: 320, maxWidth: 520, boxShadow: '0 4px 16px rgba(0,0,0,0.25)' }
const title:    React.CSSProperties = { margin: '0 0 10px 0', fontSize: 16 }
const body:     React.CSSProperties = { fontSize: 13, marginBottom: 8 }
const list:     React.CSSProperties = { margin: '4px 0 8px 18px', padding: 0, fontSize: 12 }
const row:      React.CSSProperties = { display: 'flex', gap: 8, alignItems: 'center', fontSize: 13, marginBottom: 6 }
const warn:     React.CSSProperties = { fontSize: 12, color: '#c00', marginTop: 6 }
const footer:   React.CSSProperties = { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }
const btnPri:   React.CSSProperties = { padding: '6px 14px', background: '#1976D2', color: '#fff', border: 'none', borderRadius: 3, cursor: 'pointer' }
const btnSec:   React.CSSProperties = { padding: '6px 14px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
